export default "__VITE_ASSET__NXBC236w__"